import { render, staticRenderFns } from "./RightTable.vue?vue&type=template&id=5fbc5050"
import script from "./RightTable.vue?vue&type=script&lang=js"
export * from "./RightTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports